import React from 'react';
import { useTranslation } from 'react-i18next';

function Experience() {
  const { t } = useTranslation();
  const experiences = t('experience.items', { returnObjects: true, defaultValue: [] });

  return (
    <section className="experience-section" id="experience">
      <h3>{t('experience.title')}</h3>
      {experiences.map((item, index) => (
        <div className="experience-item" key={`experience-${index}`}>
          <div className="experience-header">
            <h4>{item.title}</h4>
            {item.subtitle && <span className="subtitle">{item.subtitle}</span>}
          </div>
          {item.description && <p>{item.description}</p>}
          {Array.isArray(item.tasks) && (
            <ul>
              {item.tasks.map((task, taskIndex) => (
                <li key={`experience-${index}-task-${taskIndex}`}>{task}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </section>
  );
}

export default Experience;